import { Alert, AlertDescription } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import { isFeatureEnabled } from "@/lib/analytics";
import { isEvalOpsStaff } from "@/lib/utils/user";
import { useAuth } from "@/lib/auth/useAuth";
import { useUser } from '@/lib/contexts/UserContext';
import { ShieldAlert, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

export function StaffBanner() {
  const { user: authUser } = useAuth();
  const { user } = useUser();
  const [isDismissed, setIsDismissed] = useState(false);
  
  if (!authUser || !user || !isEvalOpsStaff(authUser.email) || !isFeatureEnabled('staff-badge') || isDismissed) {
    return null;
  }

  const displayName = user.name || `${authUser.firstName || ''} ${authUser.lastName || ''}`.trim() || user.email;

  return (
    <Alert className="border-orange-200 bg-orange-50 text-orange-900 rounded-none border-b border-t-0 border-l-0 border-r-0 relative pl-[72px]">
      <AlertDescription className="flex items-center justify-end w-full gap-2">
        <ShieldAlert className="h-4 w-4 text-orange-600 flex-shrink-0" />
        <div className="flex items-center gap-2 flex-wrap">
          <Badge variant="secondary" className="bg-orange-100 text-orange-800 hover:bg-orange-200">
            Staff User
          </Badge>
          <span className="text-sm">
            Logged in as staff user: <strong>{displayName}</strong> • All actions are logged and monitored
          </span>
          <span className="text-xs text-orange-700">
            Report any suspicious activity to security
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsDismissed(true)}
          className="text-orange-600 hover:text-orange-800 hover:bg-orange-100 h-6 w-6 p-0 flex-shrink-0 ml-2"
        >
          <X className="h-3 w-3" />
        </Button>
      </AlertDescription>
    </Alert>
  );
}